export default {"src":"/komodo/_next/static/media/gradient-link-arrow-black.40219fe5.svg","height":19,"width":18,"blurWidth":0,"blurHeight":0};